import React from 'react'
import './Advisor.scss'
import { getAdvisorLinkWithCookie } from './advisors-query-param'
import { APIENDPOINT, getCWPEnvironmentForURL, sanitizeHTML } from '../utils/common-utils'

function PhoneNumber({ phone }) {
  return <a href={`tel:+1${phone}`}>{phone}</a>
}

function AdvisorImageNoLink({ data, labels }) {
  const env = getCWPEnvironmentForURL(window.location.href)
  const src =
    data.image ||
    `${APIENDPOINT(env).baseGallery}/content/gallery/wealth-management/${labels.missingImage}`
  const alt = data.name || 'Missing Image'
  const img = <img src={src} alt={alt} className='Advisor-image u-maxWidth100' />
  return img
}

function AdvisorNameNoLink(data, classNames) {
  const header = <h3 className={classNames}>{data.name}</h3>
  return header
}

function SocialIcon({ icon, url }) {
  const icons = {
    // twitter: 'social-twitter', // disabling twitter for now due to icon change
    facebook: 'social-facebook',
    linkedin: 'social-linkedin',
  }
  if (!icons[icon]) {
    return null
  }
  return (
    <li key={icon} className='u-textSizeMsrp1 u-flexJustifyCenter u-inlineBlock u-marginRight3gu'>
      <a
        href={url}
        target='_blank'
        rel='noopener noreferrer'
        className='Icon-link BrandIconsComponent'>
        <svg
          aria-hidden='true'
          className='BrandIconsComponent--icon BrandIcon--default u-sizeXSmall u-textSizeMsrp3'>
          <use
            href={`/binaries/content/gallery/ampmicrosites/brand-icons/icon-sprite.svg#${icons[icon]}`}
          />
        </svg>
        <span className='u-hiddenVisually'>{icon}</span>
      </a>
    </li>
  )
}

function SocialIcons({ data, definedSize }) {
  const icons = Object.keys(data.social).map(icon => SocialIcon({ icon, url: data.social[icon] }))

  if (icons.length === 0) return null
  return <ul className='u-decoBorderReset'>{icons}</ul>
}

function ReferralLink({ data, labels }) {
  const referLink = data.type === 'team' ? data.urls.site : data.urls.referme
  const referLinkWithAuth = getAdvisorLinkWithCookie(referLink)
  const link = (
    <a
      className='AdvisorClient-refer Button Button--secondary Button--secondary--action-blue u-marginTop4gu u-md-sizeFull u-sm-sizeFull'
      href={referLinkWithAuth}
      target='_blank'
      rel='noopener noreferrer'>
      {labels?.referLabel}
    </a>
  )
  return referLink && labels.referLabel ? link : ''
}

function SoloAdvisor({ data, labels }) {
  const email = data.email && <p className='u-marginBottom2gu u-textBreak'>{data.email}</p>
  const phone = data.phone && <p className='u-marginBottom2gu'>{data.phone}</p>
  return (
    <div>
      <div className='AdvisorClient AdvisorClient--nextGen2024 Grid Card-body u-padding4gu'>
        <div className='u-size8of12 u-flex u-flexRow u-paddingRight4gu u-md-sizeFull u-sm-sizeFull u-sm-flexCol u-md-paddingRight0 u-sm-paddingRight0'>
          <div className='AdvisorClient-image u-marginRight4gu u-sm-marginRight0 u-sm-marginBottom4gu'>
            <AdvisorImageNoLink data={data} labels={labels} />
          </div>
          <div className='AdvisorClient-info'>
            <h5 className='AdvisorClient-advisor Heading--withSeparator u-textUppercase u-textColorMidnightBlue'>
              {labels?.advisorLabel}
            </h5>
            {AdvisorNameNoLink(
              data,
              'AdvisorClient-name u-textSecondary u-marginBottom1gu u-inlineBlock'
            )}
            {data.designations && (
              <p
                class='u-md-marginVert2gu u-sm-marginVert2gu'
                dangerouslySetInnerHTML={{ __html: sanitizeHTML(data.designations) }}></p>
            )}
            {data.title && <p dangerouslySetInnerHTML={{ __html: sanitizeHTML(data.title) }}></p>}
            <div className='u-md-hidden u-sm-hidden'>
              <ReferralLink data={data} labels={labels} />
            </div>
          </div>
        </div>

        <div class='u-lg-hidden u-size12of12'>
          <ReferralLink data={data} labels={labels} />
        </div>
        <div className='u-size4of12 u-paddingLeft4gu u-borderLeft u-md-sizeFull u-md-paddingLeft0 u-md-paddingTop4gu u-md-borderLeft0 u-md-marginTop4gu u-md-borderTop u-sm-sizeFull u-sm-paddingLeft0 u-sm-paddingTop4gu u-sm-marginTop4gu u-sm-borderLeft0 u-sm-borderTop'>
          <div className='u-textPrimary u-textColorNeutralGrey u-textBold u-marginBottom2gu'>
            Contact
          </div>
          <ul className='AdvisorClient-contactInfo List Grid'>
            {email && (
              <li className='List-item u-sizeFull u-flex u-flexAlignItemsCenter u-marginBottom1gu u-md-size6of12 u-md-marginBotton2gu u-sm-marginBottom2gu'>
                <span
                  class='adel-material-symbols u-textColorActionBlue u-marginRight2gu'
                  role='img'
                  title='happy'
                  aria-label='happy'>
                  mail
                </span>
                <a className='u-textTruncate' href={`mailto:${data.email}`}>
                  {data.email}
                </a>
              </li>
            )}
            {phone && (
              <li className='List-item u-sizeFull u-flex u-flexAlignItemsCenter u-marginBottom1gu u-md-size6of12 u-md-marginBotton2gu u-sm-marginBottom2gu'>
                <span
                  class='adel-material-symbols u-textColorActionBlue u-marginRight2gu'
                  role='img'
                  title='phone'
                  aria-label='phone'>
                  phone
                </span>
                <a href={`tel:${data.phone}`}>{data.phone}</a>
              </li>
            )}
            {data.urls.site && (
              <li className='List-item u-sizeFull u-flex u-flexAlignItemsCenter u-marginBottom1gu u-md-size6of12 u-md-marginBotton2gu u-sm-marginBottom2gu'>
                <span
                  class='adel-material-symbols u-textColorActionBlue u-marginRight2gu'
                  role='img'
                  title='new_window'
                  aria-label='new_window'>
                  new_window
                </span>
                <a href={data.urls.site} target='_blank' rel='noreferrer'>
                  Advisor website
                </a>
              </li>
            )}
            <li className='List-item u-sizeFull u-md-size6of12'>
              <SocialIcons data={data} definedSize='u-textSizeMsrp2' />
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

function TeamAdvisor({ data }) {
  return (
    <div className='Grid Grid--fit Grid--withGutter Content u-padding6gu'>
      <div>
        <h3 className='u-paddingBottom4gu'>Your advisor team</h3>
        <div className='Grid Grid--fit Grid--withGutter Content'>
          <div className='Content Content--large u-sm-marginBottom6gu u-md-marginBottom6gu'>
            {data.urls?.site && data.name && (
              <p>
                <span className='u-textBold u-textSizeMsrp1'>
                  <a href={data.urls.site}>{data.name}</a>
                </span>
              </p>
            )}
            <br />
            {data.phone && <PhoneNumber phone={data.phone} />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default function Client({ data, labels }) {
  if (data) {
    if (data.type === 'advisor') {
      return <SoloAdvisor data={data} labels={labels} />
    }
    if (data.type === 'team') {
      return <TeamAdvisor data={data} />
    }
  }
  return <div />
}
